<template>
  <v-layout wrap row class="text-left view-staff-container justify-center align-center">
    <v-card>
      <v-card-title>Mitarbeiter</v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table :loading="tableLoading"
              :headers="headers"
              :items="staff">
              <template v-slot:item.workers="{ item }">
                <p/>
                <h3>{{ item.firstName }} {{ item.lastName }}</h3>
                <p>{{ item.username }}</p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon @click="removeStaff(item)" v-on="on" color="red">delete</v-icon>
                  </template>
                  <span>{{ $t("delete") }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <v-row>
              <v-col cols="12">
                <v-btn color="primary" outlined @click="openAddUserDialog()" style="margin-left: 0">
                  <v-icon left>person_add</v-icon>
                  Mitarbeiter hinzufügen
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h2>Mitarbeiter hinzufügen</h2>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-form v-model="form" ref="staffForm" lazy-validation>
            <v-row>
              <v-col cols="12" class="text-left">
                <v-text-field
                  color="primary"
                  :label="$t('contact.firstName')"
                  :rules="rules"
                  v-model="user.firstName"
                  required/>
                <v-text-field
                  color="primary"
                  :label="$t('contact.lastName')"
                  :rules="rules"
                  v-model="user.lastName"
                  required/>
                <h3 style="margin-top: 10px; text-align: left">Anmeldedaten:</h3>
                <v-text-field
                  color="primary"
                  :label="$t('contact.email')"
                  :rules="emailRules"
                  v-model="user.username"
                  required/>
                <v-text-field
                  color="primary"
                  :label="$t('profile.password')"
                  :rules="rules"
                  v-model="user.password"
                  required/>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="secondary" text @click.native="dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :loading="loading" :disabled="loading" @click="submitStaff()">{{ $t('hotel.user.add') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :color="snackbar.result"
      v-model="snackbar.value"
      :bottom="true"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn
        color="white"
        text
        @click="snackbar.value = false">
        {{$t("close")}}
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
  export default {
    name: 'HotelStaff',
    data() {
      return {
        snackbar: {
          result: 'success',
          timeout: 6000,
          value: false,
          text: ''
        },
        staff: [],
        rules: [
          v => !!v || this.$i18n.t('form.required')
        ],
        emailRules: [
          v => !!v || this.$i18n.t('form.required'),
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$i18n.t('form.email.valid')
        ],
        headers: [
          { text: 'Mitarbeiter', value: 'workers', align: 'left', sortable: false },
          { text: this.$i18n.t('manageYieldStaff.actions'), value: 'actions', align: 'right', sortable: false }
        ],
        dialog: false,
        loading: false,
        tableLoading: false,
        form: undefined,
        user: {
          firstName: undefined,
          lastName: undefined,
          username: undefined,
          password: undefined
        }
      };
    },
    mounted() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        this.tableLoading = true;
        this.$http.get('hotels/staff').then((data) => {
          this.staff = data.body;
          this.tableLoading = false;
        });
      },
      openAddUserDialog() {
        this.user = {
          firstName: undefined,
          lastName: undefined,
          password: undefined,
          username: undefined
        };
        this.dialog = true;
        this.$refs.staffForm.reset();
      },
      removeStaff(user) {
        let index = -1;
        for (let i = 0; i < this.staff.length; i += 1) {
          if (this.staff[i].username === user.username) {
            index = i;
            break;
          }
        }
        if (index !== -1) {
          this.staff.splice(index, 1);
        }
        this.loading = true;
        this.$http.put('hotels/staff', this.staff).then(() => {
          this.loading = false;
          this.snackbar.result = 'success';
          this.snackbar.text = 'Mitarbeiterliste wurde erfolgreich aktualisiert!';
          this.snackbar.value = true;
        });
      },
      submitStaff() {
        if (this.$refs.staffForm.validate()) {
          this.loading = true;
          const staff = JSON.parse(JSON.stringify(this.staff));
          staff.push(this.user);
          this.$http.put('hotels/staff', staff).then(() => {
            this.staff.push(this.user);
            this.loading = false;
            this.dialog = false;
            this.snackbar.result = 'success';
            this.snackbar.text = 'Mitarbeiterliste wurde erfolgreich aktualisiert!';
            this.snackbar.value = true;
          }, () => {
            this.loading = false;
            this.snackbar.result = 'error';
            this.snackbar.text = 'E-Mail Adresse ist bereits vorhanden!';
            this.snackbar.value = true;
          });
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/layout";

  .view-staff-container {
    margin-top: 50px;
  }
</style>
